import { CircleStackIcon, HomeIcon, UserGroupIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLayoutStore, useUserStore } from "../../context";
import { classNames, hasRole } from "../../utils/helpers";
import constants from "../../utils/constants";

const NavItem = ({ item }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [showSubItems, setShowSubItems] = useState(false);

  const [sidebarMenuOpen, setSidebarMenuOpen] = useLayoutStore((state) => [
    state.sidebarMenuOpen,
    state.setSidebarMenuOpen,
  ]);

  const isActive = item.isHome
    ? location.pathname === "/"
    : location.pathname.startsWith(item.href) && location.pathname !== "/";

  useEffect(() => {
    if (!sidebarMenuOpen) setShowSubItems(false);
  }, [sidebarMenuOpen]);

  return (
    <Fragment key={item.name + item.href}>
      <button
        onClick={() => {
          if (item.subItems) {
            setSidebarMenuOpen(true);
            setShowSubItems((show) => !show);
          } else navigate(item.href);
        }}
        key={item.name}
        className={classNames(
          isActive ? "bg-gray-100" : "text-gray-600 hover:text-gray-700",
          "group flex items-center p-6 h-8 text-sm font-large relative w-full mt-4"
        )}
      >
        {/* Left decoration rectangle*/}
        {isActive && (
          <div className="bg-primaryColor/25 p-1 absolute left-0 h-full" />
        )}
        {/* Icon */}
        <div
          title={item.name}
          className={classNames(
            isActive
              ? "text-gray-700"
              : "text-gray-400 group-hover:text-gray-500",
            "ml-2 mr-3 flex-shrink-0 h-6 w-6"
          )}
          aria-hidden="true"
        >
          {item.icon}
        </div>
        {/* Item name */}
        {sidebarMenuOpen && (
          <div className="mx-2 whitespace-nowrap">{item.name}</div>
        )}
      </button>

      {/* Submenu Items */}
      {showSubItems &&
        item.subItems &&
        item.subItems.map((subItem, i) => {
          const isActiveSubmenu = location.pathname.startsWith(subItem.href);

          return (
            <Link
              key={subItem.href + i}
              to={subItem.href}
              className={classNames(
                isActiveSubmenu ? "text-gray-900" : "",
                "justify-center flex text-sm text-gray-400 hover:text-gray-700 h-6 p-2 items-center"
              )}
            >
              {subItem.name}
            </Link>
          );
        })}
    </Fragment>
  );
};

export default function SideNavMenu() {
  const { currentUser } = useUserStore();
  const [sidebarMenuOpen] = useLayoutStore((state) => [state.sidebarMenuOpen]);

  let NAVIGATION_ITEMS = [
    { name: "Dashboard", icon: <HomeIcon />, href: "/", isHome: true },
  ];

  if (hasRole(currentUser, constants.ROLE_NAMES.SYS_ADMIN)) {
    NAVIGATION_ITEMS = [
      ...NAVIGATION_ITEMS,
      { name: "Users", icon: <UserGroupIcon />, href: "/users" },
    ];
  } 
  // if (hasRole(currentUser, constants.ROLE_NAMES.GENERATOR)) {
  //   NAVIGATION_ITEMS = [
  //     ...NAVIGATION_ITEMS,
  //     { name: "Build App", icon: <CircleStackIcon />, href: "/buildapp"}
  //   ];
  // }
  if (hasRole(currentUser, constants.ROLE_NAMES.GENERATOR)) {
    NAVIGATION_ITEMS = [
      ...NAVIGATION_ITEMS,
      { name: "Generate app", icon: <WrenchScrewdriverIcon />, href: "/generator"}
    ];
  }

  return (
    <Fragment>
      <div
        className={classNames(
          sidebarMenuOpen ? "w-64" : "w-20",
          "fixed top-16 flex min-h-0 flex-1 flex-col border-r border-gray-200 bg-white float-left h-[calc(100vh-4rem)] shadow-2xl z-5 transform duration-200"
        )}
      >
        <div className="flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          <nav className="flex-1 space-y-3 bg-white" aria-label="Sidebar">
            {NAVIGATION_ITEMS.map((item, i) => (
              <NavItem key={item.href + i} item={item} />
            ))}
          </nav>
        </div>
        <hr />
      </div>
    </Fragment>
  );
}
